<template>
  <v-layout wrap>
    <v-flex
      xs12
      md6
      mb-5
      v-for="(featureGroupId, index) in featureGroupIds"
      :key="index + '-h'"
    >
      <h3>{{ featureName(featureGroupId) }}</h3>
      <v-divider />
      <features-from-group
        v-model="value"
        :key="index"
        :parent-module-name="parentModuleName"
        :feature-group-ids="[featureGroupId]"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import FeaturesFromGroup from './FeaturesFromGroup'

export default {
  name: 'FeaturesByGroup',

  data () {
    return {
      features: []
    }
  },

  components: {
    FeaturesFromGroup
  },

  props: {
    field: {
      type: Object,
      default: () => {
        return {}
      }
    },

    featureGroupIds: {
      type: Array,
      default: () => {
        return []
      }
    },

    parentModuleName: {
      type: String,
      default: null
    },

    parentId: {
      type: String,
      default: null
    },

    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    modules () {
      return this.$store.getters.modules
    },

    language () {
      return this.$store.getters.language
    }
  },

  watch: {
    parentId (value, before) {
      this.subtableSelectedId = null
    }
  },

  created () {
    let useFeaturesFrom = this.modules[this.parentModuleName].useFeaturesFrom
    if (useFeaturesFrom) {
      this.features = this.$store.getters['moduleListLinkItems'][useFeaturesFrom].features
    }
  },

  methods: {
    featureName (id) {
      const foundFeature = this.features.filter((feature) => {
        if (!feature.group) {
          console.log('MISSING', feature, feature.group)
        }
        return feature.group && feature.group._id === id
      })[0]
      return foundFeature && foundFeature.group && (
        foundFeature.group['groupName_' + this.language] || foundFeature.group.groupName_en
      )
    }
  }
}
</script>
